<ng-content select="[header]"></ng-content>
@if (isOpen) {
  <div (clickOutside)="close()" [delayClickOutsideInit]="true">
    <ng-content select="[items]"></ng-content>
  </div>
}
